import api from "./client";

export function getAttorneyInbox() {
  return api.get("/attorney/inbox");
}
